import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { ReportStatusEnum } from '../enums/report-status.enum';
import { ReportTypeEnum } from '../enums/report-type.enum';

/**
 * Reports filters
 */
export class ReportsFilters extends ApiRequestFilters {
	/**
	 * Status values
	 */
	statuses?: ReportStatusEnum[];

	/**
	 * Type values
	 */
	types?: ReportTypeEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
